export enum LoanOriginationSystemEditBorrowerActionType {
  UpdateBorrower = 'loanOriginationSystemEditBorrower/updateBorrower',
  UpdateBorrowerSuccess = 'loanOriginationSystemEditBorrower/updateBorrowerSuccess',
  UpdateBorrowerFailure = 'loanOriginationSystemEditBorrower/updateBorrowerFailure',
  UpdateBorrowerApplications = 'loanOriginationSystemEditBorrower/updateBorrowerApplications',
  UpdateBorrowerApplicationsSuccess = 'loanOriginationSystemEditBorrower/updateBorrowerApplicationsSuccess',
  UpdateBorrowerApplicationsFailure = 'loanOriginationSystemEditBorrower/updateBorrowerApplicationsFailure',
}
